import { z } from 'zod';

import { NoemirError } from '../contracts/errors';

const environmentSchema = z
  .object({
    VITE_NOEMIR_APP_NAME: z.string().trim().min(1).default('Noemir'),
    VITE_NOEMIR_ENV: z.enum(['development', 'test', 'production']).default('development'),
    VITE_NOEMIR_LOG_LEVEL: z.enum(['error', 'warn', 'info', 'debug']).default('info'),
    VITE_NOEMIR_ENABLE_DEV_DEMO: z.enum(['true', 'false']).default('false'),
  })
  .loose();

export interface FrontendEnvironment {
  readonly appName: string;
  readonly environment: 'development' | 'test' | 'production';
  readonly logLevel: 'error' | 'warn' | 'info' | 'debug';
  readonly enableDevDemo: boolean;
}

export const parseFrontendEnvironment = (input: Record<string, unknown>): FrontendEnvironment => {
  const result = environmentSchema.safeParse(input);

  if (!result.success) {
    throw new NoemirError({
      code: 'invalid_environment',
      message: 'The frontend environment is invalid.',
      retryable: false,
      details: {
        fields: result.error.issues.map((issue) => issue.path.join('.')).join(', '),
      },
    });
  }

  return {
    appName: result.data.VITE_NOEMIR_APP_NAME,
    environment: result.data.VITE_NOEMIR_ENV,
    logLevel: result.data.VITE_NOEMIR_LOG_LEVEL,
    enableDevDemo: result.data.VITE_NOEMIR_ENABLE_DEV_DEMO === 'true',
  };
};
